import { gql } from '@apollo/client';
import { CreatorAndModifierById, ListReferenceUser } from '../../types';
import { useLazyGraphql } from 'utils/hooks/useLazyGraphql';

export const fetchListReferenceCreatorsAndModifiers = gql`
  fragment userInfo on User {
    id
    fullName
    avatarUrl
  }
  query getListReferenceCreatorsAndModifiers {
    campaignCreators {
      ...userInfo
    }
    campaignModifiers {
      ...userInfo
    }
    workflowCreators {
      ...userInfo
    }
    workflowModifiers {
      ...userInfo
    }
  }
`;

type CreatorsAndModifiersResponse = {
  campaignModifiers: ListReferenceUser[];
  campaignCreators: ListReferenceUser[];
  workflowCreators: ListReferenceUser[];
  workflowModifiers: ListReferenceUser[];
};

export const useCreatorsAndModifiersQuery = () => {
  const {
    data: {
      campaignCreators = [],
      campaignModifiers = [],
      workflowCreators = [],
      workflowModifiers = [],
    } = {},
    fetch,
  } = useLazyGraphql<CreatorsAndModifiersResponse>(fetchListReferenceCreatorsAndModifiers);

  const creatorsAndModifiers = [
    ...campaignModifiers,
    ...campaignCreators,
    ...workflowCreators,
    ...workflowModifiers,
  ];

  const creatorsAndModifiersById = creatorsAndModifiers.reduce(
    (acc, curr) => ({
      ...acc,
      [curr.id]: curr,
    }),
    {} as CreatorAndModifierById,
  );

  return {
    creatorsAndModifiersById,
    fetch,
  };
};
